module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "inp-input",
    class: {
      'error': _vm.error,
      'right': _vm.right
    }
  }, [(!_vm.textarea) ? _c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "maxlength": _vm.length,
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": function($event) {
        _vm.keydown($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "paste": function($event) {
        _vm.paste($event)
      },
      "input": function($event) {
        _vm.input($event)
      }
    }
  }) : _c('textarea', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "rows": _vm.rows,
      "maxlength": _vm.length,
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": function($event) {
        _vm.keydown($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "input": function($event) {
        _vm.input($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b28e544"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/InputText/InputText.vue.html
// module id = Whox
// module chunks = 2